import React from 'react';
import { Form } from 'react-bootstrap';
import { FormNumber } from '~/components/FormControl';

function ConditionAfterDetail() {
    return (
        <Form.Row className="justify-content-between">
            <FormNumber
                name="conditionAfterDetail.conditionAfterModifiedDvValue"
                sm={3}
                tooltip="How much DV will be changed after the first condition effect ends?"
            />
            <FormNumber
                name="conditionAfterDetail.conditionAfterModifiedAttackValue"
                sm={3}
                tooltip="How much strike will be changed after the first condition effect ends?"
            />
            <FormNumber
                name="conditionAfterDetail.conditionAfterModifiedDefenseValue"
                sm={3}
                tooltip="How much block will be changed after the first condition effect ends?"
            />
        </Form.Row>
    );
}

export default ConditionAfterDetail;
